import React, { Dispatch, SetStateAction, useCallback } from 'react';
import { MenuState } from '@components/MainStage/types';
import { ReactFlowId } from '@constants/entities/reports';
import { useProject } from '@context/Project';

const useCanvasContextMenu = ({
  openMenu,
  setMenu,
}: {
  openMenu: () => void;
  setMenu: Dispatch<SetStateAction<MenuState | null>>;
}) => {
  const { drawer } = useProject();

  const onCanvasContextMenu = useCallback(
    (event: MouseEvent | React.MouseEvent) => {
      event.preventDefault();
      if (drawer) return;

      const pane = document
        .querySelector(`#${ReactFlowId}`)
        ?.getBoundingClientRect();

      if (!pane) return;

      setMenu({
        id: 'canvas',
        type: 'canvas',
        top: event.clientY - pane.top,
        left: event.clientX - pane.left,
      });

      openMenu();
    },
    [drawer],
  );

  return { onCanvasContextMenu };
};

export default useCanvasContextMenu;
